export const appName = "Digicust";